module.exports = __webpack_public_path__ + "img/thumbs-up.75bdf717.svg";